
import { Component, Vue } from "vue-property-decorator";
import request from "@/lib/request/request";

@Component({ components: {} })
export default class AiGroup extends Vue {
  passwd = "";
  dashboardOutId = "";

  //设备查询
  isMobile(): boolean {
    const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    const isAndroid = /(Android)/i.test(navigator.userAgent);
    return isIos || isAndroid;
  }

  created() {
    if (this.isMobile()) return;

    const params = this.$route.query;
    if (params.dashboardOutId) {
      this.dashboardOutId = String(params.dashboardOutId);
    } else {
      this.$message.error("链接不正确，请核对后再试");
    }
  }
  toLogin() {
    if (!this.passwd) {
      this.$message.warning("请输入验证码");
      return;
    }
    request
      .post("/aiExam/dashboardPublic/get", {
        dashboardOutId: this.dashboardOutId,
        Passwd: this.passwd
      })
      .then(res => {
        if (res) {
          const previewUrl = `/data-cockpit?dashboardOutId=${this.dashboardOutId}`;
          localStorage.setItem("cockpitPasswd", this.passwd);
          localStorage.setItem("cockpitType", res.data.data.type);
          this.$router.push(previewUrl);
        } else {
          this.$message.error("验证码错误");
        }
      });
  }
}
